import { useSelector } from 'react-redux';
import { Link, useHistory } from 'react-router-dom';
import I18n from 'i18n-js';

import { ScrollContainer } from '~/components/atoms/ScrollContainer';
import StyledButton, {
  EStyledButtonVariant,
} from '~/components/atoms/StyledButton';
import { MenuViewHeader } from '~/components/MenuViewHeader';
import { CaptchaOverlay } from '~/components/molecules/CaptchaOverlay';
import {
  EPlatform,
  PlatformButton,
} from '~/components/molecules/PlatformButton';

import { LoginFooter } from '~/popups/LoginPopup/LoginFooter';
import { useSocialRegister } from '~/popups/RegisterPopup/useSocialRegister';
import { previousPathSelector } from '~/redux/slices/location/selectors';
import { EMAIL_REGISTER_PATH, LOGIN_PATH, MENU_PATH } from '~/routes/paths';

import styles from './RegisterPopup.module.scss';

export function RegisterPopup(): JSX.Element {
  const history = useHistory();
  const previousPath = useSelector(previousPathSelector);
  const { captcha, setSelectedProvider } = useSocialRegister();

  return (
    <CaptchaOverlay
      showCaptcha={captcha.isRequired}
      onChange={captcha.onChange}
      dismissCaptcha={captcha.dismiss}
    >
      <MenuViewHeader
        onBack={
          previousPath === LOGIN_PATH
            ? () => history.goBack()
            : () => history.push(LOGIN_PATH)
        }
        title={I18n.t('MenuView_register_bc')}
        onClose={() => history.replace(MENU_PATH)}
      />
      <ScrollContainer>
        <section className={styles.container}>
          <PlatformButton
            platform={EPlatform.FACEBOOK}
            onProviderClick={setSelectedProvider}
          />
          <PlatformButton
            platform={EPlatform.GOOGLE}
            onProviderClick={setSelectedProvider}
          />
          <PlatformButton
            platform={EPlatform.APPLE}
            onProviderClick={setSelectedProvider}
          />
          <StyledButton
            variant={EStyledButtonVariant.BLUE}
            className={styles.emailButton}
            onClick={() => {
              history.push(EMAIL_REGISTER_PATH);
            }}
          >
            {I18n.t('MenuView_continuewithemail')}
          </StyledButton>
          <span className={styles.registerInfo}>
            {I18n.t('MenuView_has_account')}
            <Link
              to={LOGIN_PATH}
              className={styles.loginLink}
            >
              {I18n.t('MenuView_button_login')}
            </Link>
          </span>
        </section>
      </ScrollContainer>
      <LoginFooter />
    </CaptchaOverlay>
  );
}
